<template>
    <div>
        <PageTitle :title="$t('perfil_invitaciones.invitaciones_eventos')"/>
        <section class="padding-vertical-content">
            <b-container class="text-center">
                <b-row class="d-flex justify-content-center">
                    <b-col cols="12" lg="8">
                        <p class="lead text-muted text-center px-3">
                            {{ $t('perfil_invitaciones.informacion') }}
                        </p>
                    </b-col>
                    <b-col cols="12" lg="8" class="mb-4">
                        <div class="card shadow card-custom text-center h-100">
                            <div class="card-body d-flex flex-column justify-content-center">
                                <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.total_invitaciones_temporada') }}</h5>
                                <h2 class="card-number text-success">{{ invitaciones?.invitaciones_abonado?.n_total_temporada }}</h2>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="d-flex justify-content-center mb-3">
                    <b-col cols="12" lg="8">
                        <b-row>
                            <b-col cols="6">
                                <div class="card shadow card-custom text-center h-100">
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.invitaciones_consumidas') }}</h5>
                                        <h2 class="card-number text-danger d-flex align-items-center justify-content-center">
                                            {{ invitaciones?.invitaciones_abonado?.n_total_consumidas }}
                                            <b-button 
                                                variant="link" 
                                                class="p-0 ml-1 icon-only-button"
                                                @click="showModal('invitaciones-abono-' + abono_id)"
                                            >
                                                <p class="h4 mt-2">
                                                    <b-icon 
                                                        icon="info-circle-fill" 
                                                        class="text-danger" 
                                                    />
                                                </p>
                                            </b-button>
                                        </h2>
                                    </div>
                                </div>
                            </b-col>

                            <b-col cols="6">
                                <div class="card shadow card-custom text-center h-100">
                                    <div class="card-body d-flex flex-column justify-content-center">
                                        <h5 class="card-title text-muted">{{ $t('perfil_invitaciones.invitaciones_restantes') }}</h5>
                                        <h2 class="card-number text-primary">{{ invitaciones?.invitaciones_abonado?.n_total_disponibles }}</h2>
                                    </div>
                                </div>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>

            <hr class="section-divider" />

            <b-container>
                <b-row class="d-flex justify-content-center">
                    <b-col cols="12" lg="8">
                        <div class="card shadow-lg card-table">
                            <div class="card-header altcolor-content text-white text-center">
                                <h5 class="mb-0">{{ $t('perfil_invitaciones.eventos_disponibles')}}</h5>
                            </div>
                            <div class="card-body p-0">
                                <b-table
                                    striped
                                    hover
                                    small
                                    responsive
                                    :items="eventos"
                                    :fields="fields"
                                >
                                    <template #cell(opciones)="row">
                                        <router-link
                                            v-if="!row.item.all_invitaciones_consumidas && row.item.tiene_zonas_con_invitaciones !== false"
                                            :to="'/perfil/abono/' + abono_id + '/invitaciones/' + row.item.id + '/' + row.item.sesion_id"
                                            class="button small-button effect-button sitecolor-content rounded"
                                        >
                                            <span>{{ $t('perfil_invitaciones.generar_invitaciones') }}</span>
                                        </router-link>
                                        <button v-else to="#" class="button small-button sitecolor-content rounded disabled" style="cursor: not-allowed;">
                                            <span>{{ $t('perfil_invitaciones.invitaciones_agotadas') }}</span>
                                        </button>
                                    </template>
                                </b-table>
                                <LoaderComponent v-if="loading"/>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-container>

            <ModalComponent
                :name="'invitaciones-abono-' + abono_id"
                :title="$t('perfil_invitaciones.invitaciones_consumidas')"
                @close="closeModal('invitaciones-abono-' + abono_id)"
            >
                <div v-if="!loadingConsumidas">
                    <b-table
                        v-if="invitacionesConsumidas.length > 0"
                        striped
                        hover
                        small
                        responsive
                        :items="invitacionesConsumidas"
                        :fields="fieldsConsumidas"
                    />
                    <div v-else>
                        <p class="text-center">{{ $t('perfil_invitaciones.no_invitaciones_consumidas') }}</p>
                    </div>
                </div>
                <LoaderComponent 
                    v-if="loadingConsumidas"
                />
                <PaginateComponent
                    v-if="invitacionesConsumidas.length > 0"
                    :current_page="paginationConsumidas.current_page" 
                    :last_page="paginationConsumidas.last_page"
                    v-on:change_page="setPageConsumidas"
                />
            </ModalComponent>
        </section>
    </div>
</template>

<script>
    import PageTitle from '@/components/frontend/shared/PageTitle';
    import ModalComponent from '@/components/backend/components/ModalComponent';
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import PaginateComponent from '@/components/table/pagination/BackPaginateComponent';

    export default {
        props: {
            abono_id: {
                type: [String, Number],
                required: true
            }
        },
        data() {
            return {
                eventos: [],
                invitaciones: [],
                invitacionesConsumidas: [],
                loading: false,
                paginationConsumidas: {},
            }
        },
        methods: {
            showModal(name) {
                this.$modal.show(name);
            },
            closeModal(name) {
                this.$modal.hide(name);
            },
            getInvitaciones() {
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.abonados'), { abonado_id: this.abono_id }).then(res => {
                    this.invitaciones = res.data.data;
                });
            },
            getEventos() {
                this.loading = true;
                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.abonados.eventos'), { abonado_id: this.abono_id }).then(res => {
                    this.eventos = res.data.data;
                }).finally(() => {
                    this.loading = false;
                });
            },
            getInvitacionesConsumidas() {
                this.loadingConsumidas = true;

                const data = {
                    filters: {
                        page: this.paginationConsumidas.current_page,
                        abonado_id: this.abono_id
                    },
                    abonado_id : this.abono_id,
                }

                this.$store.dispatch(this.config.getVuexAlias('front.perfil.invitaciones.abonados.consumidas'), data).then(res => {
                    this.invitacionesConsumidas = res.data.data;
                    this.paginationConsumidas = res.data.meta;
                    this.loadingConsumidas = false;
                }).finally(() => {
                    this.loadingConsumidas = false;
                });
            },
            formatDate(value) {
                if (!value) return '';
                return value.split(' ')[0];
            },
            setPageConsumidas(page) {
                this.paginationConsumidas.current_page = page;
                this.getInvitacionesConsumidas();
            }
        },
        computed: {
            teatro() {
                return this.$store.getters.getTeatro;
            },
            fieldsConsumidas() {
                return [
                    { key: 'evento.name', label: this.$t('perfil_invitaciones.evento') },
                    { key: 'created_at', label: this.$t('perfil_invitaciones.fecha'), formatter: this.formatDate },
                    { key: 'user.name', label: this.$t('perfil_invitaciones.invitado') }
                ];
            },
            fields() {
                return [
                    { key: 'name', label: this.$t('perfil_invitaciones.evento'), class: 'text-center' },
                    { key: 'start_event_date', label: this.$t('perfil_invitaciones.fecha'), class: 'text-center', formatter: this.formatDate },
                    { key: 'invitaciones_restantes', label: this.$t('perfil_invitaciones.invitaciones'), class: 'text-center' },
                    { key: 'opciones', label: this.$t('perfil_invitaciones.opciones'), class: 'text-center' }
                ];
            }
        },
        created() {
            if (!this.teatro.invitaciones_para_abonados) {
                this.$router.go(-1);
            } else {
                this.getInvitaciones();
                this.getEventos();
                this.getInvitacionesConsumidas();
            }
        },
        components: {
            PageTitle, ModalComponent, LoaderComponent, PaginateComponent
        }
    }
</script>

<style scoped>
    .card-custom {
        border-radius: 1rem;
        transition: transform 0.2s ease, box-shadow 0.2s ease;
    }
    .card-custom:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 20px rgba(0,0,0,0.15);
    }
    .card-number {
        font-size: 2.5rem;
        font-weight: bold;
    }
    .card-table {
        border-radius: 1rem;
        overflow: hidden;
    }
    .card-table .card-header {
        font-weight: bold;
        font-size: 1.2rem;
    }
    .section-divider {
        border: none;
        border-top: 3px solid #dee2e6;
        margin: 1.4rem 0;
        width: 100%;
    }
    .icon-only-button {
        padding: 0 !important;
        border: none !important;
        background: none !important;
        cursor: pointer;
    }
</style>